/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPostLoginDecisionData_creditApplications_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null };

export type GetPostLoginDecisionData_creditApplications_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly recordType: string | null, readonly appVersion: number | null, readonly bdcOrgId: string | null, readonly status: _Types.CreditApplicationStatus | null, readonly authorizedSigner: GetPostLoginDecisionData_creditApplications_CreditApplication_authorizedSigner_CreditApplicationPerson | null };

export type GetPostLoginDecisionData_Query = { readonly __typename: 'Query', readonly salesforceContactExists: boolean, readonly creditApplications: ReadonlyArray<GetPostLoginDecisionData_creditApplications_CreditApplication> | null };


export type GetPostLoginDecisionDataVariables = _Types.Exact<{ [key: string]: never; }>;


export type GetPostLoginDecisionData = GetPostLoginDecisionData_Query;


export const GetPostLoginDecisionDataDocument = gql`
    query GetPostLoginDecisionData {
  salesforceContactExists
  creditApplications {
    salesforceCreditId
    recordType
    appVersion
    bdcOrgId
    status
    authorizedSigner {
      id
      email
    }
  }
}
    `;

/**
 * __useGetPostLoginDecisionData__
 *
 * To run a query within a React component, call `useGetPostLoginDecisionData` and pass it any options that fit your needs.
 * When your component renders, `useGetPostLoginDecisionData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostLoginDecisionData({
 *   variables: {
 *   },
 * });
 */
export function useGetPostLoginDecisionData(baseOptions?: Apollo.QueryHookOptions<GetPostLoginDecisionData, GetPostLoginDecisionDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostLoginDecisionData, GetPostLoginDecisionDataVariables>(GetPostLoginDecisionDataDocument, options);
      }
export function useGetPostLoginDecisionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostLoginDecisionData, GetPostLoginDecisionDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostLoginDecisionData, GetPostLoginDecisionDataVariables>(GetPostLoginDecisionDataDocument, options);
        }
export function useGetPostLoginDecisionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostLoginDecisionData, GetPostLoginDecisionDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostLoginDecisionData, GetPostLoginDecisionDataVariables>(GetPostLoginDecisionDataDocument, options);
        }
export type GetPostLoginDecisionDataHookResult = ReturnType<typeof useGetPostLoginDecisionData>;
export type GetPostLoginDecisionDataLazyQueryHookResult = ReturnType<typeof useGetPostLoginDecisionDataLazyQuery>;
export type GetPostLoginDecisionDataSuspenseQueryHookResult = ReturnType<typeof useGetPostLoginDecisionDataSuspenseQuery>;
export type GetPostLoginDecisionDataQueryResult = Apollo.QueryResult<GetPostLoginDecisionData, GetPostLoginDecisionDataVariables>;